import type { Icon, IconWeight } from '@phosphor-icons/react';

/** Any Phosphor glyph. Components take this, never a concrete icon. */
export type IconComponent = Icon;

/**
 * One icon family (Phosphor), one weight, set in a single place. Mixed weights
 * are the fastest way to make a toolbar look assembled rather than designed.
 */
export const ICON_WEIGHT: IconWeight = 'regular';
